export default __webpack_public_path__ + "static/media/GigLinked_Logo_Black.1e7a9ae2.svg";